import Util from '../../core/utils/Util';
import Log from '../../common/log';
import { ProductAnalyticsTag } from '../../common/Constants';
import ExperimentVariant from './ExperimentVariant';
/**
 * Experiment
 */
export default class Experiment {
    /**
     * Parses the API response and converts it to ExperimentVariant objects
     * @param response The response string from the API
     * @returns Array of ExperimentVariant objects or null if parsing fails
     */
    static parse(response) {
        let responseParsed;
        let variants;
        try {
            if (response || response.trim() !== '') {
                responseParsed = JSON.parse(response);
            }
            else {
                responseParsed = null;
            }
            if (Array.isArray(responseParsed)) {
                variants = [];
                responseParsed.forEach((item) => {
                    if (typeof item !== 'object' || item === null) {
                        item = {};
                    }
                    const itemObj = item;
                    let experiment = itemObj.experiment;
                    let variant = itemObj.variant;
                    if (typeof experiment !== 'object' || experiment === null) {
                        experiment = {};
                    }
                    if (typeof variant !== 'object' || variant === null) {
                        variant = {};
                    }
                    const experimentCode = typeof experiment.code === 'string' ? experiment.code : '';
                    const variantCode = typeof variant.code === 'string' ? variant.code : '';
                    const variantPayload = variant.payload && typeof variant.payload === 'object' ? variant.payload : null;
                    if (experimentCode !== '' || variantCode !== '') {
                        variants === null || variants === void 0 ? void 0 : variants.push(new ExperimentVariant(experimentCode, variantCode, variantPayload));
                    }
                });
            }
            else {
                variants = null;
            }
        }
        catch (error) {
            Log.error(ProductAnalyticsTag, 'Error parsing experiments response:', error);
            variants = null;
        }
        return variants;
    }
    /**
     * Fetch URL
     */
    static fetch(method, url, params, body, onSuccess, onFail) {
        try {
            const xhr = new XMLHttpRequest();
            xhr.open(method, `${url}${Util.toQueryString(params)}`);
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) {
                    // Not ready yet...
                }
                else if (xhr.status >= 200 && xhr.status < 400) {
                    if (onSuccess) {
                        onSuccess(xhr.status, xhr.responseText);
                    }
                }
                else {
                    if (onFail) {
                        onFail(xhr.status);
                    }
                }
            };
            xhr.onerror = () => {
                if (onFail) {
                    onFail(-1);
                }
            };
            xhr.ontimeout = () => {
                if (onFail) {
                    onFail(-1);
                }
            };
            xhr.send(body);
        }
        catch (_a) {
            onFail(-1);
        }
    }
    /**
     * Constructor
     * @param accountCode
     * @param userId
     * @param profileId
     * @param deviceId
     */
    constructor(accountCode, userId, profileId, deviceId) {
        this.accountCode = accountCode;
        this.userId = userId;
        this.profileId = profileId;
        this.deviceId = deviceId;
        this.experimentVariants = [];
    }
    /**
     * Fetch experiment variants
     */
    fetch() {
        const url = 'https://experiments.npaw.com/assign';
        const params = { accountCode: this.accountCode };
        if (this.userId) {
            params['userId'] = this.userId;
        }
        if (this.profileId) {
            params['profileId'] = this.profileId;
        }
        if (this.deviceId) {
            params['deviceId'] = this.deviceId;
        }
        Experiment.fetch('GET', url, params, null, (status, response) => {
            const variants = Experiment.parse(response);
            if (variants) {
                this.experimentVariants = variants;
                Log.debug(ProductAnalyticsTag, `Loaded ${variants.length} experiment variants`);
            }
            else {
                this.experimentVariants = [];
                Log.warn(ProductAnalyticsTag, `Failed parsing experiment variants`);
            }
        }, (status) => {
            this.experimentVariants = [];
            Log.warn(ProductAnalyticsTag, `Failed to fetch experiment variants: HTTP ${status}`);
        });
    }
    /**
     * Get variant
     * @param code
     */
    getVariant(experimentCode) {
        return this.experimentVariants.find((ev) => ev.experimentCode === experimentCode) || null;
    }
}
